import React, { useState, useContext, createRef, useEffect } from 'react';
import { Item, Header,Menu,Checkbox, Card, Container, Segment, Sticky, Grid, Input, GridRow, Divider, GridColumn, ButtonContent } from 'semantic-ui-react';
import { Button, Form, Icon, Image, List, Label, Transition, Modal } from 'semantic-ui-react';
import {  Link, useParams, Redirect } from 'react-router-dom';
import { AppState } from '../../context';
import Cookies from 'js-cookie';
import { dbTasks, dbCaregivers, dbFamMember } from '../../firebase';
import CaregiverProfile from './CaregiverProfile';

const HomePageCaregiver = ({userr}) => {
  
  const someContext = useContext(AppState);
  const {
    pending,
    correct,
    setCorrect,
    familyMembers,
    tasks,
    caregivers,
  } = someContext;
  const [activeItem, setActiveItem] = useState('tasks');
  const {userid} = useParams();
  const contextRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailOpen, setisDetailModelOpen]=useState(false);
  const [existingTasks,setTasks]=useState([]) ////// this is the variable we gunna use for a task
  const [caregiverId, setCaregiverId]=  useState(userid)
  const [famID, setFamID]=useState("")
  const [famFirstName, setFamFirstName]=useState("");
  const [famLastName, setFamLastName]=useState("");
  const [statuss, setStatus]=useState("");
  const [detailss, setDetails]=useState("");
  const [famPhone, setFamPhone]=useState("");
  const [typee, setType]=useState("");
  const [taskidlist, setTaskidlist]=useState([])
  const [notes,setNotes]=useState("");
  const [todayDate, setDate]=useState(new Date())
  const [todayString, setTodayString]=useState(todayDate.toString())

  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
      console.log(snappy3.val())
      setFamID(snappy3.val()[caregiverId].familyMembers)
      console.log(snappy3.val()[caregiverId].familyMembers);
      setTasks(snappy3.val()[caregiverId].todolist)
      setNotes(Object.keys(snappy3.val()[caregiverId].notes))
        
      
    //   console.log("crucial check")
    //   console.log(snappy3.val())
    }
    dbCaregivers.on('value',initialzeName,error=>alert(error));
    return ()=>{dbCaregivers.off('value',initialzeName)}
  }, []);

  useEffect(()=>{
    const  initializeFam = (snappy2) =>{
      if(snappy2.val()[famID]){
      setFamFirstName(snappy2.val()[famID]["firstName"])
      console.log(snappy2.val()[famID])
      setFamLastName(snappy2.val()[famID]["lastName"])
      setFamPhone(snappy2.val()[famID]["phone"])
      
      }
  console.log(famID);
  }
    
    dbFamMember.on('value',initializeFam,error=>alert(error));
    return ()=>{dbFamMember.off('value',initializeFam)}
  }, [famID]);
  
  function Update_click(status) {
    if (tasks) {
      let new_status = !tasks[status.input]["status"];
      dbTasks.child(status.input).update({
        "status": new_status, 
        "statusLastChecked": {'.sv': 'timestamp'}
        
      })
      console.log("reached inside");
    }
  }
  useEffect(() => {
    const handleClose = () => {
      if (caregivers && caregivers[caregiverId] && caregivers[caregiverId]["tasks"]) {
        let a = caregivers[caregiverId]["tasks"];
        console.log("this is a")
        console.log(a);
        const result = Object.values(a);
        setTaskidlist(result);
        console.log(result);
        console.log("RAN THE INSIDE")

      }
      console.log("RAN THE FUNCTION")
    };
    handleClose();
  }, [caregivers]);


  function helper11(input) {
    function testToday(){
      if(tasks[input]['duebydate']){

      
      var date= new Date(tasks[input]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(tasks[input]['createdOn'])
      console.log(createdonDate)
      var todaystime= new Number(todayDate)
      var timedue= new Number(tasks[input]['duebydate'])
      if(date.getDay() == todayDate.getDay() && tasks[input]['frequency']=="Weekly" && todaystime>=timedue){
        console.log("2nd")
        console.log(todayString)
        console.log(date)

        return true;
      }
      else if(tasks[input]['frequency']==="Everyday" || tasks[input]['frequency']==="Twice a Day" && todaystime>=timedue ){
        console.log("third")
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return true;
    }
    }
   

    if (tasks && familyMembers && input && tasks[input] && !tasks[input]["status"] && testToday()) {
      var  temp;
      var date= new Date(tasks[input]["createdOn"]);
              console.log(date)
              temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
              if(date.getMinutes() < 10 ){
                temp=temp+"0"+date.getMinutes().toString();
              } else{
                temp=temp+date.getMinutes().toString();
              }
      return (
        <List.Item>
          <List.Icon>
            <Checkbox checked={tasks[input]["status"]} onClick={() => Update_click({ input })} />
          </List.Icon>
          <List.Content>
            <List.Description>
            </List.Description>
           <List.Header as="a">{tasks[input]["taskName"] + ":"}</List.Header>
              <List.Description as="a"> At  {tasks[input]["time"]} </List.Description>
              {/* for
                                          {" " + tasks[input]["duration"]} */}
              <List.Description as="a">{tasks[input]["description"]} <strong>{tasks[input]["importance"]} Importance </strong></List.Description>
              <List.Description as="a"> Assigned on  {temp} </List.Description>

            </List.Content>
        </List.Item>
      )
    }
    else {
      return null;
    }
  }
  function helper22(input) {
    function testToday(){
      if(tasks[input]['duebydate']){

      
      var date= new Date(tasks[input]['duebydate']);
      var arry=date.toString().split(" ");
      console.log("this is the date")
      console.log(arry);
      console.log(todayString.toString().split(" "));
      if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
        console.log('correctomondo')
        return true;
      }
      var createdonDate=new Date(tasks[input]['createdOn'])
      console.log(createdonDate)
      var todaystime= new Number(todayDate)
      var timedue= new Number(tasks[input]['duebydate'])
      if(date.getDay() == todayDate.getDay() && tasks[input]['frequency']=="Weekly" && todaystime>=timedue){
        console.log("correct2")
        return true;
      }
      else if(tasks[input]['frequency']==="Everyday" || tasks[input]['frequency']==="Twice a Day" && todaystime>=timedue ){
        console.log("correct3")

        return true;
      }
      else{
        return false;
      }
    }
    else{
      return true;
    }
    }

    if (tasks && familyMembers && input && tasks[input] && tasks[input]["status"]&& testToday()) {
      var  temp;
      var date= new Date(tasks[input]["statusLastChecked"]);
              console.log(date)
              temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
              if(date.getMinutes() < 10 ){
                temp=temp+"0"+date.getMinutes().toString();
              } else{
                temp=temp+date.getMinutes().toString();
              }
      return (
        <List.Item>
          <List.Icon>
            <Checkbox checked={tasks[input]["status"]} onClick={() => Update_click({ input })} />
          </List.Icon>
          <List.Content>
           <List.Header as="a">{tasks[input]["taskName"] + ":"}</List.Header>
              <List.Description as="a"> At {/*tasks[input]["seniorFirstName"]*/}
                {tasks[input]["time"]} </List.Description>
                {/* for
                                          {" " + tasks[input]["duration"]} */}
              <List.Description as="a">{tasks[input]["description"]} <strong>{tasks[input]["importance"]} Importance </strong></List.Description>
              <List.Description as="a"> Completed on  {temp} </List.Description>

            </List.Content>
        </List.Item>
      )
    }
    else {
      return null;
    }
  }

  function WriteFirebase(detaiils){
    var temp=existingTasks;
    var size=existingTasks.length;
//     temp.push()
//       dbCaregivers.push()
    
//    }
    
    dbCaregivers.child(caregiverId).child("todolist").update({
      [size]: {status:false, detail:detaiils, type:statuss, createdOn: {'.sv': 'timestamp'}} || null
    })
  }
  
  function reboot(){
   
  }

  const PageHeader = () => {
    return (
      <Segment
      basic
      clearing
      style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
      fluid="true"
    >     
      <Menu pointing compact>
          <Menu.Item
            name='home'
            active={activeItem === 'tasks'}
            onClick={()=>setActiveItem('tasks')}
          />   
          <Menu.Item
            name='Notes'
            active={activeItem === 'notes'}
            onClick={()=>setActiveItem('notes')}
          /> 
          <Menu.Item
            name={famFirstName+'s Tasks'}
            active={activeItem === 'home'}
            onClick={()=>setActiveItem('home')}
          />
          <Menu.Item
            icon='user'
            style={{
              color: 'white',backgroundColor: "#006990"
          }
          }
            active={false}
            onClick={()=>setActiveItem('profile')}
          />
      </Menu>

      {/* <Button primary positive floated right circle onClick={()=>setIsModalOpen(true)}>Add Task for {famFirstName}</Button> */}

     
      </Segment>
    );
  };
  function EachItemU1({ id }) {

    if (pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);
      console.log(date)
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      }

      return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' color='green' ribbon>
                Completed
        </Label>
              <span><strong>{pending ? pending[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Completed  on:</strong> {temp}</List.Item>

              {/* <List.Item> <strong>Duration:</strong> {famtofam ? famtofam[id]["duration"] : ""}</List.Item> */}
              {/* <List.Item> <strong>Caregiver Notes:</strong> {"137/84, Pulse: 65"}</List.Item> */}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else if (!pending[id]["status"]) {
      var temp;
      var date = new Date(pending[id]["createdOn"]);
      console.log(date)
      temp = ((date).getMonth() + 1).toString() + "/" + (date).getDate().toString() + " at " + (date).getHours().toString() + ":";
      if (date.getMinutes() < 10) {
        temp = temp + "0" + date.getMinutes().toString();
      } else {
        temp = temp + date.getMinutes().toString();
      } return (
        <Grid.Row>
          <Grid.Column>
            <Segment raised>
              <Label as='a' ribbon>
                Incomplete
        </Label>
              <span><strong>{pending ? pending[id]["taskName"] : ""}</strong></span>
              <List.Item> <strong>Description:</strong> {pending ? pending[id]["description"] : ""}</List.Item>
              <List.Item> <strong>Assigned  on:</strong> {temp}</List.Item>

              {/* <List.Item> <strong>Duration:</strong> {famtofam ? famtofam[id]["duration"] : ""}</List.Item> */}
            </Segment>
          </Grid.Column>
        </Grid.Row>);
    }
    else {
      return null;
    }
  }
  const TodoList=({active})=>{
    console.log()
    console.log(familyMembers[famID])
   if(active)
    return(
    <Container>
        <Transition.Group
          as={List}
          duration={1000}
          divided
          relaxed
          verticalAlign='middle'
        >
          <Grid padded>
          {caregivers ? existingTasks.map((input) => helper1(input)) : ""}
          {caregivers ? existingTasks.map((input) => helper2(input)) : ""}
          </Grid>
          
          <Grid padded>
        {/* {familyMembers[famID]["unassignedTasks"] !== "null" && pending ? Object.values(familyMembers[famID]["unassignedTasks"]).map((input) => <EachItemU1 id={input}/>) : ""} */}
        </Grid>
        </Transition.Group>
      </Container>);
      else{
        return null
      }
  };
  const TaskList=({active})=>{
    if(active)
    return(
      <Container>
        <Transition.Group
        as={List}
        duration={1000}
        divided
        relaxed
        verticalAlign='middle'
      >

        <Header style={{marginTop: '10px', marginBottom:'10px'}}as='h2' textAlign="center">Your Tasks Today</Header>
        
        {caregivers ? taskidlist.map((input) => helper11(input)) : ""}
        {caregivers ? taskidlist.map((input) => helper22(input)) : ""}
       
      </Transition.Group>
    </Container>);
      else{
        return null
      }
  };

  function noteshelper(id){
  
    return(
      
      <Item>
          <Item.Content>
            <Item.Header as='a'>{caregivers[caregiverId]["notes"][id]["title"]}</Item.Header>
            <Item.Meta>{caregivers[caregiverId]["notes"][id]["description"]}</Item.Meta>
          </Item.Content>
        </Item>
    )
  }

  const Notes = ({active})=>{
    if(active && notes!="null"){
      return <div>
     <Container style={{marginTop: 25}} padded>
    <Item.Group paddded style={{marginLeft:"10px",marginRight:"10px"}}>
      {notes.map((id)=>noteshelper(id))}
    </Item.Group>
    <Container>
            <Button padded floated="center" fluid content="Add Notes" circular icon='add' as={Link} to={`/caregivers/addNote/${caregiverId}`} />
        </Container>
    </Container>

    </div>
    }
    else if(active){
      return(<div>
        
        <Container>
            <Button padded floated="center" fluid content="Add Notes" circular icon='add' as={Link} to={`/caregivers/addNote/${caregiverId}`} />
        </Container>
      </div>
      )
    }
    else{
      return null
    }
  }

  
  const ModalDetail= () =>{
    return(
    <Modal as={Form} open={isDetailOpen} basic size='small' onSubmit={() => WriteFirebase()} onClose={() => {setisDetailModelOpen(false) }}>
          <Header icon='checkmark' content='Complete!' />
          <Modal.Content>
          <Form size="large">
              <Form.Group widths='equal'>
                <Form.Input id="inputDetails"
                  required={true}
                  label='Details'
                />
              </Form.Group>
            </Form>
           
          {/* onChange={(e)=>setDetails(e.target.value)} */}
          </Modal.Content>
          <Modal.Actions>
            {/* <Form>
                <Form.Group>
                    <Form.Input label="Details" onChange={(e)=>setDetails(e.target.value)} required ={true} placeholder="e.g. Bananas, Apples, etc." />
                </Form.Group>
            </Form> */}
            <Button type= "submit" color='green' inverted onClick={()=>{
                setisDetailModelOpen(false)
                console.log(document.getElementById("inputDetails").value)
                WriteFirebase(document.getElementById("inputDetails").value);
            }}>
                    <Icon name='pen square' /> Done
            </Button>
          </Modal.Actions>
    </Modal>);
  }
  // function Update_click(status) {
  //   if (tasks) {
  //     let new_status = !caregivers[caregiverId]["todolist"][status.input]["status"];
  //     dbCaregivers.child(caregiverId).child(status.input).update({
  //       "status": new_status
  //     })
  //   }
  // }
function helper1(input) {
  var temp;
       if (!input["status"] &&!input["sample"]) {

        var date= new Date(input["createdOn"]);
        console.log(date)
        temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
        if(date.getMinutes() < 10 ){
          temp=temp+"0"+date.getMinutes().toString();
        } else{
          temp=temp+date.getMinutes().toString();
        }
        return (
          <Grid.Row syle={{marginTop: '-10px'}}>
            <Grid.Column>
              <Segment raised>
                <Label as='a' color='yellow' ribbon>
                  Not Yet Read 
                </Label>
            <span>
              <strong>{input["type"]}</strong></span>
                <List.Item> <strong>Details:</strong> {input["detail"]}</List.Item>
                <List.Item> <strong>Assigned on:</strong> {temp}</List.Item>
              </Segment>
          </Grid.Column>
        </Grid.Row>
        )
      }
      else {
        return null;
      }
    }
function helper2(input) {
  var  temp;
  var date= new Date(input["statusLastChecked"]);
            console.log(date)
            temp =((date).getMonth()+1).toString() +"/"+ (date).getDate().toString() +" at "+ (date).getHours().toString() + ":";
            if(date.getMinutes() < 10 ){
              temp=temp+"0"+date.getMinutes().toString();
            } else{
              temp=temp+date.getMinutes().toString();
            }

       if (input["status"]) {
        return (
          <Grid.Row>
            <Grid.Column>
          
          <Segment raised>
            <Label as='a' color='green' ribbon>
            Completed 
            </Label>
        <span>
          <strong>{input["type"]}</strong></span>
            <List.Item> <strong>Details:</strong> {input["detail"]}</List.Item>
            <List.Item> <strong>Completed on:</strong> {temp}</List.Item>
          </Segment>
          </Grid.Column>
          </Grid.Row>
        )}
      // }
      else {
        return null;
      }
    }

  return (
    correct || Cookies.get('caregiverlogged') == userid?
    <div ref={contextRef}>
      <Sticky context={contextRef} >
        <PageHeader />
        {/* <Divider hidden />
        <Divider hidden /> */}
        {/* <Divider hidden /> */}
        <ModalDetail />
        <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
          <Header icon='checkmark' content='Complete!' />
          <Modal.Content>
      <p>
              What's come up for {famFirstName}?
      </p>
          </Modal.Content>
          <Modal.Actions>
      <Button color='green' inverted  onClick={()=>{
            setisDetailModelOpen(true);
            setIsModalOpen(false);
            setStatus("buy");}

            }>
              <Icon name='pen square' /> Some thing(s) to Buy
      </Button>
      <Button color='green' inverted  onClick={()=>{
          setisDetailModelOpen(true);
          setIsModalOpen(false);
          setStatus("appointment");
        }
          
          }>
              <Icon name='pen square' /> Appointment Update
      </Button>
      <Button color='green' inverted  onClick={()=>{
          setisDetailModelOpen(true);
          setIsModalOpen(false)
          setStatus("update")}
          }>
              <Icon name='pen square' /> General Update
      </Button>
      <Button color='green' inverted  onClick={()=>{
          setIsModalOpen(false);
          setisDetailModelOpen(true);
          setStatus("other");
          }}>
              <Icon name='pen square' /> Other
      </Button>
          </Modal.Actions>
        </Modal>
        <TodoList active={activeItem=='home'}/>
        <TaskList active={activeItem=='tasks'} />
        <Notes active={activeItem=='notes'} />
        <CaregiverProfile active={activeItem=='profile'} />
       <Grid>
         <Grid.Column textAlign="center">
           
        <Button style={{marginTop:"40px"}} icon labelPosition="left" positive onClick={()=>setIsModalOpen(true)}>
        Add Task for {famFirstName}
          <Icon name = 'plus square' />

        </Button>
        </Grid.Column>
        </Grid>

      </Sticky>
    </div>: <Redirect to={'/caregivers'} push={true} />
  );
}

export default HomePageCaregiver;